export default __webpack_public_path__ + "static/realWorldImg4-9a5282f190b05eef437cb31866fb260b.png";